import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useUserStore } from "@/stores/user";
import { Plus } from "lucide-react";

interface PromoCodesHeaderProps {
  onCreatePromoCode: () => void;
  promoCodesCount: number;
  enablePromoCodesInForm: boolean;
  onEnablePromoCodesInFormChange: (enabled: boolean) => void;
}

export function PromoCodesHeader({
  onCreatePromoCode,
  promoCodesCount,
  enablePromoCodesInForm,
  onEnablePromoCodesInFormChange,
}: Readonly<PromoCodesHeaderProps>) {
  const { hasFullAccess } = useUserStore();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold tracking-tight">Promo Codes</h1>
          <h3 className="text-lg ml-2 text-muted-foreground self-start mt-1">
            ({promoCodesCount})
          </h3>
        </div>
        {hasFullAccess() && (
          <Button onClick={onCreatePromoCode} className="gap-2">
            <Plus className="h-4 w-4" />
            Add Promo Code
          </Button>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Switch
          id="enable-promo-codes-in-form"
          checked={enablePromoCodesInForm}
          onCheckedChange={onEnablePromoCodesInFormChange}
        />
        <Label
          htmlFor="enable-promo-codes-in-form"
          className="cursor-pointer"
        >
          Enable promo codes in form
        </Label>
      </div>
    </div>
  );
}
